import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import readXlsxFile from 'read-excel-file'
import { useTranslation } from 'react-i18next'

import { Text } from 'components/forms'
import { FileXls } from 'media/icons'
import { UploadLabel, UploadInputWrapper } from './styled'

const UploadInput = ({ onUpload, useFirstfileRow }) => {
	const [fileName, setFileName] = useState('')
	const [inputError, setInputError] = useState('')
	const [t] = useTranslation()
	const handleUpload = e => {
		const file = e.target.files[0]
		if(file) {
			setFileName(file.name)
			readXlsxFile(file)
				.then(rows => {
					onUpload(rows)
					if(inputError) {
						setInputError('')
					}
				})
				.catch(err => setInputError('Can not get data from the file. Probably file is broken.'))
		}
	}

	return(
		<Fragment>
			<UploadLabel>
				<input hidden type='file' onChange={handleUpload} accept='.xlsx' multiple={false} />
				<UploadInputWrapper>
					<Text
						noForm
						label={`${t('loyalty_card_section.fields.file_name')} (*.xlsx)`}
						value={fileName}
						readOnly
						error={inputError}
					/>
					<FileXls className='ico-file' />
				</UploadInputWrapper>
			</UploadLabel>
		</Fragment>
	)
}

UploadInput.propTypes = {
	onUpload: PropTypes.func.isRequired,
	useFirstfileRow: PropTypes.bool
}

export default UploadInput
